import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SetPatientAction } from "../../actions";
import { AuthService, PatientService, UtilService } from "../../services";
import { Store } from "@ngrx/store";
import { Patient } from "../../models";
import { StateService } from "../../services/state/state.service";
import { StateModel } from "../../models/state.model";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";

@Component({
  selector: "app-new-patient-additional-details-modal",
  templateUrl: "./patient-additional-details-modal.component.html",
  styleUrls: ["./patient-additional-details-modal.component.scss"]
})
export class PatientAdditionalDetailsNewModalComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;

  public redirect: string;

  public years: Array<number> = [];
  public states: Array<StateModel> = [];
  public modalRef: any;
  public patient: Patient;
  public confirm: boolean = false;

  public editMode: boolean = false;
  public modalTitle = "Add Additional Patient Info";
  public showPatientExistsError = false;
  public isOfficeStaff: boolean;
  public nextButtonText = "NEXT";

  private subscriptions: { [name: string]: Subscription } = {};

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    container: "app-new-patient-additional-details-modal",
    keyboard: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private utilService: UtilService,
    private stateService: StateService,
    private store: Store<any>,
    private patientService: PatientService,
    private authService: AuthService,
    private location: Location
  ) {}

  ngOnInit() {
    this.subscriptions["state"] = this.stateService.get().subscribe(value => {
      this.states = value;
    });

    this.subscriptions["route"] = this.route.queryParams.subscribe(params => {
      this.redirect = params["redirect"] || "";
    });
    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(patient => {
        this.patient = Object.assign({}, new Patient(), patient);
      });
    this.isOfficeStaff = false; //this.authService.getUser().Role === "staff";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  get hasAddress() {
    return !!(this.patient.Address1 || "").trim();
  }

  get isButtonEnabled() {
    return true;
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
    for (let sub in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(sub)) {
        this.subscriptions[sub].unsubscribe();
      }
    }
  }

  canSkip() {
    return false;
  }

  back() {
    this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
    this.location.back();
  }

  skip() {
    let navigationExtras: NavigationExtras = {
      queryParams: { redirect: this.redirect }
    };
    this.router.navigate(["/patients/create/billing"], navigationExtras);
  }

  update() {
    this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
    this.skip();
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/patient-additional-details-modal/patient-additional-details-new-modal.component.ts